<div *ngIf="showForms | async">
    <mat-card  appearance="outlined"  class="mb-3">
        <mat-card-content>
            <div id="addAssetsForm"></div>
        </mat-card-content>
    </mat-card>
</div>